export const invalidCompany = {
  title: 'Неправильна компанія',
  description: 'Будь ласка, перевір компанію або сконтактуй адміна',
  button: 'Додому',
};
